import { IN_STOCK_DELIVERY_ESTIMATES } from "../../../pages/leasing/leasing-product-page.constants";

export const getIsOfferInStock = (
  deliveryEstimate: string | null | undefined,
) => {
  return (
    !!deliveryEstimate && IN_STOCK_DELIVERY_ESTIMATES.includes(deliveryEstimate)
  );
};
